import { render } from "./SuperFundsEditModalPopup.vue?vue&type=template&id=ca70372c&scoped=true"
import script from "./SuperFundsEditModalPopup.vue?vue&type=script&lang=js"
export * from "./SuperFundsEditModalPopup.vue?vue&type=script&lang=js"

import "./SuperFundsEditModalPopup.vue?vue&type=style&index=0&id=ca70372c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca70372c"]])

export default __exports__